import { render, staticRenderFns } from "./productRecommendations.vue?vue&type=template&id=f2381016&scoped=true&"
import script from "./productRecommendations.vue?vue&type=script&lang=js&"
export * from "./productRecommendations.vue?vue&type=script&lang=js&"
import style0 from "./productRecommendations.vue?vue&type=style&index=0&id=f2381016&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2381016",
  null
  
)

export default component.exports